import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MaintenancesApi } from '@api/maintenances/maintenances.api';
import { AuthenticationService } from '@core/authentication/authentication.service';
import { Maintenance, Quotation, QuotationExpense } from '@core/interfaces';
import { formatUrl } from '@core/utils/attachments-utils';
import { FuseProgressBarService } from '@fuse/components/progress-bar/progress-bar.service';
import { DialogEditMaintenanceComponent } from 'app/main/maintenances/dialogs/dialog-edit-maintenance/dialog-maintenances.component';

@Component({
  selector: 'tab-general',
  templateUrl: './tab-general.component.html',
  styleUrls: ['./tab-general.component.scss']
})
export class TabGeneralComponent implements OnInit {
  @Input() quotation: Quotation;
  @Input() isViewMode: boolean;
  public hasPaymentsBetaFlag = this.authenticationService.hasFlags('paymentsFeatureFlag');
  public expensesTotalValue = 0;

  public hasEditMaintenancePermission = this.authenticationService.hasPermission('maintenances-edit');
  public hasLabelViewPermission = this.authenticationService.hasPermission('labels-list');

  constructor(
    private matDialog: MatDialog,
    private fuseProgressBarService: FuseProgressBarService,
    private authenticationService: AuthenticationService,
    private maintenancesApi: MaintenancesApi
  ){}

  public ngOnInit(): void {
    for (const expense of this.quotation.expenses || []) {
      this.expensesTotalValue += expense.value;
    }
  }

  async editDialog(maintenance: Maintenance, isViewMode: boolean): Promise<void> {
    this.fuseProgressBarService.show();

    maintenance = await this.maintenancesApi.searchOne(this.quotation.maintenance.id).toPromise();
    this.fuseProgressBarService.hide();

    await this.matDialog.open(DialogEditMaintenanceComponent, {
      panelClass: 'dialog-edit-maintenance',
      data: {
        maintenance,
        isViewMode
      }
    })
      .afterClosed()
      .toPromise();
  }

  public openReceipt(item: QuotationExpense): void {
    window.open(formatUrl(item.path), '_blank');
  }
}
